export default __webpack_public_path__ + "static/media/MarsCentra-Book.f94fa42d.woff2";